import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { emailList, emailAdd, emailUpdate, emailRemove } from "../../Redux/Actions/emailAddActions";
import { getEnums } from "../../Redux/Actions/enumsActions";
import { columnsEmailList } from "../../Global Functions/columnsAntd";
import TableComponent from "../../Global Functions/tableComponents";
import toast from "react-hot-toast";
import EmailEditModal from "./addAndUpdateEmail";
import { Button, Modal } from "antd";

const ListEmail = () => {
    const dispatch = useDispatch();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedEmail, setSelectedEmail] = useState(null);
    const [tempSearch, setTempSearch] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["5", "10", "20", "50", "100"],
    });

    //   const { admin } = useSelector((state) => state.admin || {});
    //   const accessCode = admin?.data?.access_code || [];
    //   const canAdd = Array.isArray(accessCode) && accessCode.includes('add_email');
    //   const canEdit = Array.isArray(accessCode) && accessCode.includes('edit_email');
    //   const canDelete = Array.isArray(accessCode) && accessCode.includes('delete_email');

    const fetchDetails = useCallback(
        (showLoader = true) => {
            const payload = {
                page: pagination.current,
                limit: pagination.pageSize,
                search: searchQuery,
            };
            return dispatch(emailList(payload, showLoader)).catch(() => {
                if (showLoader) {
                    toast.error("Failed to fetch email list");
                }
            });
        },
        [dispatch, pagination.current, pagination.pageSize, searchQuery]
    );

    const emailState = useSelector((state) => state.emailAdd || {});
    const emails = useMemo(() => {
        return emailState.emails?.data || [];
    }, [emailState.emails]);
    const emailTotal = useMemo(() => {
        return emailState.emails?.total || 0;
    }, [emailState.emails]);
    const { loading } = emailState;

    useEffect(() => {
        dispatch(getEnums());
    }, [dispatch]);

    const enumsData = useSelector((state) => state.enumsData);

    useEffect(() => {
        fetchDetails(true);
    }, [fetchDetails]);

    useEffect(() => {
        setPagination((prev) => ({ ...prev, total: emailTotal }));
    }, [emailTotal]);

    const openEditModal = useCallback((email = null) => {
        setSelectedEmail(email);
        setIsModalOpen(true);
    }, []);


    const closeEditModal = () => {
        setSelectedEmail(null);
        setIsModalOpen(false);
    };

    const filterHandler = () => {
        setSearchQuery(tempSearch);
        setPagination((prev) => ({ ...prev, current: 1 }));
    };

    const handleDelete = (emailId) => {
        Modal.confirm({
            title: "Confirm Delete",
            content: "Are you sure you want to delete this email?",
            okText: "Yes, Delete",
            okType: "danger",
            cancelText: "Cancel",
            onOk: async () => {
                try {
                    await dispatch(emailRemove(emailId));
                    // toast.success("Email removed successfully");
                    fetchDetails(false);
                } catch (error) {
                    toast.error("Failed to delete email");
                }
            },
        });
    };

    const handleSubmit = async (values) => {
        const prevEmails = emailState.emails?.data || [];

        const isDuplicateEmail = prevEmails.some(
            (email) =>
                email.email === values.email &&
                email._id !== selectedEmail?._id
        );

        if (isDuplicateEmail) {
            toast.error("Email already exists");
            return { success: false };
        }

        try {
            let result;
            if (selectedEmail?._id) {
                result = await dispatch(emailUpdate({
                    id: selectedEmail._id,
                    ...values
                }));
                // toast.success("Email updated successfully");
            } else {
                result = await dispatch(emailAdd(values));
            }

            if (result) {
                fetchDetails(false);
                closeEditModal();
                return { success: true };
            }
        } catch (error) {
            toast.error("Failed to save email");
            return { success: false };
        }
    };

    const handleTableChange = (pagination) => {
        setPagination(pagination);
        fetchDetails(false);
    };


    return (
        <>
            <div style={{ position: "absolute", marginTop: "9.6%", marginLeft: "86.5%" }}>

                <Button
                    style={{ background: "#0D1A52", color: "white", padding: "18px", borderRadius: "20px" }}
                    onClick={() => openEditModal(null)}
                >
                    Add Email
                </Button>
            </div>

            <TableComponent
                pagination={pagination}
                filterFunction={filterHandler}
                onPressEnter={filterHandler}
                setState={setTempSearch}
                dataSource={emails}
                onChange={handleTableChange}
                h3heading="Email List"
                columns={columnsEmailList(pagination.current, pagination.pageSize, handleDelete, openEditModal)}
                loading={loading}
            />

            {isModalOpen && (
                <EmailEditModal
                    visible={isModalOpen}
                    emailData={selectedEmail}
                    onSave={handleSubmit}
                    onClose={closeEditModal}
                    enumsData={enumsData}
                />
            )}
        </>
    );
};

export default ListEmail;
